import { render, staticRenderFns } from "./FileManage.vue?vue&type=template&id=24d23080&scoped=true&"
import script from "./FileManage.vue?vue&type=script&lang=js&"
export * from "./FileManage.vue?vue&type=script&lang=js&"
import style0 from "./FileManage.vue?vue&type=style&index=0&id=24d23080&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d23080",
  null
  
)

export default component.exports